import { render } from "./Leaderboard.vue?vue&type=template&id=4c57bc46"
import script from "./Leaderboard.vue?vue&type=script&lang=js"
export * from "./Leaderboard.vue?vue&type=script&lang=js"

import "./Leaderboard.vue?vue&type=style&index=0&id=4c57bc46&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__